import { Cell, cellID } from './cell'
import { Interpreter } from './interpreter'
import { Value, Expr } from './ast'
import { Stack } from './stack';

class Sheet {
    rows: number;
    cols: number;
    grid: Cell[][]

    constructor(rows: number, cols: number) {
        this.rows = rows;
        this.cols = cols;
        this.grid = []
        for (let i = 0; i < rows; i++) {
            let row = [];
            this.grid.push(row);
            for (let j = 0; j < cols; j++) {
                const id = cellID(i, j);
                const cell = new Cell(id, i, j);
                row[j] = cell;
            }
        }
    }

    compute(): Map<string, Value> {
        const interp = new Interpreter(this.code());
        interp.compute();
        return interp.values;
    }

    code(): Expr[][][] {
        return this.grid.map(r => r.map(c => c.code))
    }

    import(text: string) {
        const rows = text.split("\n");
        const cells = rows.map(r => r.split("|"));
        this.grid.forEach((r, i) =>
            r.forEach((c, j) => {
                if (cells[i] && cells[i][j])
                    c.formula = cells[i][j].trim();
                else
                    c.formula = "";
            })
        )
    }

    export(): string {
        const contentIndices =
            this.grid.map(r =>
                r.map(c => c.formula).reverse().findIndex(f => f.length > 0));
        const emptyRows =
            contentIndices.slice().reverse().findIndex(i => i >= 0);
        if (emptyRows == -1)
            return "";
        let rows = this.grid;
        if (emptyRows > 0) {
            rows = rows.slice(0, rows.length - emptyRows);
        }
        return rows.map((row, i) => {
            let r = row;
            if (contentIndices[i] > 0)
                r = r.slice(0, r.length - contentIndices[i]);
            return r.map(cell => cell.formula.padStart(10, " ")).join(" | ")
        }).join("\n")
    }
}

export { Sheet }
